var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.renderChart)?_c('div',[(_vm.isAccuracyAvailable)?_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('chart-container',{attrs:{"chart":{
            desc: 'FAQ Accuracy',
            type: 'doughnut',
            data: _vm.predictionAccuracy,
          }}})],1)],1):_c('el-row',[_c('el-col',{attrs:{"span":24}},[_c('p',[_vm._v("FAQ Accuracy is not available")]),_c('small',{staticStyle:{"margin-bottom":"20px","display":"inline-block"}},[_vm._v(" This is probably caused by examples not trained yet or empty examples. ")])])],1)],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }